export const isVehicleType = (str: unknown): boolean => (!!((
  typeof str === 'string' && (str === 'commercial'
  || str === 'passenger'
  || str === 'sedan'
  || str === 'luxury'
  || str === 'hatchback'
  || str === 'mpv'
  || str === 'suv'
  || str === 'sports'
  || str === 'stationwagon'
  || str === 'hybrid'
  || str === 'electric'))));
